import { render, staticRenderFns } from "./Payrunpayslips.vue?vue&type=template&id=0d3caf38"
import script from "./Payrunpayslips.vue?vue&type=script&lang=js"
export * from "./Payrunpayslips.vue?vue&type=script&lang=js"
import style0 from "./Payrunpayslips.vue?vue&type=style&index=0&id=0d3caf38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports